import {AI_PROMO_STATUSES} from '../../configs/aiMatch';

const JOINABLE_STATUSES = new Set([AI_PROMO_STATUSES.WAITING, AI_PROMO_STATUSES.COUNTDOWN]);
// Баны и выбор фракций (starting) — состав уже зафиксирован, как и в идущем
// матче: сервер пускает только зрителем (см. planAiPromoJoin)
const WATCHABLE_STATUSES = new Set([AI_PROMO_STATUSES.STARTING, AI_PROMO_STATUSES.GAME_STARTED]);

/**
 * Можно ли войти в промо-лобби с ИИ игроком: лобби дня есть и матч еще не
 * начался (ждет игроков или идет отсчет). На этом держатся промо-модалка меню
 * и кнопка с отсчетом «Сбор игроков …» / «Старт через …» (getAiPromoCountdown).
 *
 * @param {Object|null} aiPromo - результат normalizeAiPromo
 * @returns {boolean}
 */
export const checkIfAiPromoJoinable = (aiPromo) => Boolean(aiPromo?.lobbyId)
  && JOINABLE_STATUSES.has(aiPromo.status);

/**
 * Матч с ИИ уже начинается или идет — кнопка меню зовет смотреть его
 * зрителем. Отмененный день и сыгранный матч сюда не попадают: кнопки нет.
 *
 * @param {Object|null} aiPromo - результат normalizeAiPromo
 * @returns {boolean}
 */
export const checkIfAiPromoWatchable = (aiPromo) => Boolean(aiPromo?.lobbyId)
  && WATCHABLE_STATUSES.has(aiPromo.status);
